module.exports = "/images/AIW_Stores_Map.png?f500849877b004643aabff6b66c10e64";